import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import SingleSelect from '../SingleSelect';
import useStyles from './styles';

/**
 * A triple single-select input for choosing one option
 */
const TripleSingleSelect = props => {
  const { options, values, rootClassName, onChange } = props;
  const classes = useStyles();

  const handleChange = name => values => {
    onChange({
      name,
      values
    });
  };

  return (
    <Grid className={`${classes.tripleSelectContainer} ${rootClassName}`}>
      {options.map((option, index) => (
        <SingleSelect
          id={`${option.value}-${index}`}
          key={`${option.value}-${index}`}
          placeholder={option.title}
          options={option.options}
          values={values[option.name]}
          onChange={handleChange(option.name)}
        />
      ))}
    </Grid>
  );
};

TripleSingleSelect.propTypes = {
  /**
   * Array of options for the dropdown lists
   */
  options: PropTypes.array.isRequired,
  /**
   * An object with key as the question.id and value as an array with one object.
   */
  values: PropTypes.object,
  /**
   * Classname for the root div
   */
  rootClassName: PropTypes.string,
  /**
   * Function to call when option selected
   */
  onChange: PropTypes.func.isRequired
};

TripleSingleSelect.defaultProps = {
  values: [],
  rootClassName: ''
};

export default TripleSingleSelect;
